"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderCellMultiLineTwo = exports.renderCellMultiLineOne = exports.renderCell = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _table = require("../../data/table");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _dateHelper = require("../../../helpers/dateHelper");
var _numberFormatter = require("../../../helpers/numberFormatter");
var _Tooltip = _interopRequireDefault(require("../../common/Tooltip/Tooltip"));
var _FuturesAddEditTPSLModal = _interopRequireDefault(require("../../FuturesAddEditTPSL/FuturesAddEditTPSLModal"));
var _FuturesClosePositionModal = _interopRequireDefault(require("../../FuturesClosePositionModals/FuturesClosePositionModal"));
var _Button = require("../../form/Button/Button");
require("./FuturesOpenPositions.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var baseClass = (0, _cssClassesHelper.getBEMClasses)('futures-open-positions-table');

/**
 *
 * @param {React.ReactNode} line1
 * @param {React.ReactNode} line2
 */

var renderCell = exports.renderCell = function renderCell(line1, line2) {
  var primarySecondLine = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var cellClass = primarySecondLine ? 'cell-line2-primary' : 'cell-line2';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClass('cell')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClass('cell-line1')
  }, line1), !!line2 && /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClass(cellClass)
  }, line2));
};
var renderCellMultiLineOne = exports.renderCellMultiLineOne = function renderCellMultiLineOne(item1, item2, item3) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClass('cell')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClass('cell-line1')
  }, item1, " ", item2), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClass('cell-line2')
  }, item3));
};
var renderCellMultiLineTwo = exports.renderCellMultiLineTwo = function renderCellMultiLineTwo(item1, item2, item3) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClass('cell')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClass('cell-line1')
  }, item1), /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClass('cell-line2-multi')
  }, item2, " ", item3));
};
var formatMoney = function formatMoney(value, product) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (0, _numberFormatter.formatNumberToLocale)(value, product), /*#__PURE__*/_react["default"].createElement("span", {
    className: "-currency"
  }, product));
};
var formatPercentage = function formatPercentage(value) {
  return "(".concat((0, _numberFormatter.formatNumberToLocale)(value, 2), "%)");
};
var FuturesOpenPositionsComponent = function FuturesOpenPositionsComponent(_ref) {
  var data = _ref.data,
    fetching = _ref.fetching,
    config = _ref.config,
    notionalProduct = _ref.notionalProduct,
    openAddEditTPSLModal = _ref.openAddEditTPSLModal,
    openClosePositionModal = _ref.openClosePositionModal;
  var _useTranslation = (0, _reactI18next.useTranslation)('futures'),
    t = _useTranslation.t;
  var maxLines = config.maxLines,
    usePagination = config.usePagination;
  var columns = (0, _react.useMemo)(function () {
    return [{
      header: t('Pair'),
      id: 'InstrumentSymbol',
      cell: function cell(_ref2) {
        var _row$original$instrum;
        var row = _ref2.row;
        return renderCellMultiLineTwo((_row$original$instrum = row.original.instrument) === null || _row$original$instrum === void 0 ? void 0 : _row$original$instrum.Symbol, row.original.PositionType, "".concat(row.original.Leverage, "x"));
      }
    }, {
      header: t('Size / Value'),
      id: 'positionValue',
      cell: function cell(_ref3) {
        var _row$original$basePro, _row$original$quotePr;
        var row = _ref3.row;
        return renderCell(formatMoney(row.original.PositionSize, (_row$original$basePro = row.original.baseProduct) === null || _row$original$basePro === void 0 ? void 0 : _row$original$basePro.Product), formatMoney(row.original.PositionValue, (_row$original$quotePr = row.original.quoteProduct) === null || _row$original$quotePr === void 0 ? void 0 : _row$original$quotePr.Product), true);
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Entry / Mark Price'),
      id: 'EntryPrice',
      cell: function cell(_ref4) {
        var _row$original$Average, _row$original, _row$original2, _row$original$quotePr2, _row$original$quotePr3;
        var row = _ref4.row;
        return renderCell(formatMoney(// First time the BE is called it returns an AverageEntryPrice, subsequent calls return EntryPrice
        (_row$original$Average = (_row$original = row.original) === null || _row$original === void 0 ? void 0 : _row$original.AverageEntryPrice) !== null && _row$original$Average !== void 0 ? _row$original$Average : (_row$original2 = row.original) === null || _row$original2 === void 0 ? void 0 : _row$original2.EntryPrice, (_row$original$quotePr2 = row.original.quoteProduct) === null || _row$original$quotePr2 === void 0 ? void 0 : _row$original$quotePr2.Product), formatMoney(row.original.MarkPrice, (_row$original$quotePr3 = row.original.quoteProduct) === null || _row$original$quotePr3 === void 0 ? void 0 : _row$original$quotePr3.Product), true);
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Liquidation Price'),
      id: 'LiquidationPrice',
      cell: function cell(_ref5) {
        var _row$original$Estimat, _row$original3, _row$original4, _row$original$quotePr4;
        var row = _ref5.row;
        return row.original.LiquidationPrice ? renderCell(formatMoney(// First time the BE is called it returns an EstimatedLiquidationPrice, subsequent calls return LiquidationPrice
        (_row$original$Estimat = (_row$original3 = row.original) === null || _row$original3 === void 0 ? void 0 : _row$original3.EstimatedLiquidationPrice) !== null && _row$original$Estimat !== void 0 ? _row$original$Estimat : (_row$original4 = row.original) === null || _row$original4 === void 0 ? void 0 : _row$original4.LiquidationPrice, (_row$original$quotePr4 = row.original.quoteProduct) === null || _row$original$quotePr4 === void 0 ? void 0 : _row$original$quotePr4.Product)) : '—';
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        text: t('Value reserved from your balance upon opening each position.')
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: baseClass('tooltip-header')
      }, t('Initial Margin'))),
      id: 'initialMargin',
      cell: function cell(_ref6) {
        var row = _ref6.row;
        return renderCell(formatMoney(row.original.InitialMargin, row.original.SettlementProductSymbol), formatMoney(row.original.InitialMarginNotional, notionalProduct.Product));
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        text: t('Value required in your futures balance to maintain positions open and avoid liquidation.')
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: baseClass('tooltip-header')
      }, t('Maint. Margin'))),
      id: 'maintenanceMargin',
      cell: function cell(_ref7) {
        var row = _ref7.row;
        return renderCell(formatMoney(row.original.MaintenanceMargin, row.original.SettlementProductSymbol), formatMoney(row.original.MaintenanceMarginNotional, notionalProduct.Product));
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        text: t('Indicates the current, "paper" profit or loss of each open futures position.')
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: baseClass('tooltip-header')
      }, t('Unrealized P&L'))),
      id: 'unrealizedPnL',
      cell: function cell(_ref8) {
        var row = _ref8.row;
        return renderCellMultiLineOne(formatMoney(row.original.UnrealizedProfitAndLoss, row.original.SettlementProductSymbol), formatPercentage(row.original.UnrealizedProfitAndLossPercentage), formatMoney(row.original.UnrealizedProfitAndLossNotional, notionalProduct.Product));
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        text: t('Indicates the actual cumulative profit or loss derived from one or more closed portions in each position (if any).')
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: baseClass('tooltip-header')
      }, t('Realized P&L'))),
      id: 'realizedPnL',
      cell: function cell(_ref9) {
        var row = _ref9.row;
        return renderCell(formatMoney(row.original.RealizedProfitAndLoss, row.original.SettlementProductSymbol), formatMoney(row.original.RealizedProfitAndLossNotional, notionalProduct.Product));
      },
      meta: {
        textAlign: 'right'
      }
    }, {
      header: t('Date Opened'),
      id: 'dateOpened',
      cell: function cell(_ref0) {
        var row = _ref0.row;
        return renderCell((0, _dateHelper.formatDate)(row.original.DateTimeOpened), (0, _dateHelper.formatTime)(row.original.DateTimeOpened));
      },
      meta: {
        textAlign: 'right'
      }
    },
    // TPSL should show here if exists for a given position according to AC
    // TPSL is not a response param currently though, so we will add it later if BE adds it
    {
      header: t('TP/SL'),
      id: 'TPSL',
      cell: function cell(_ref1) {
        var row = _ref1.row;
        var position = row.original;
        var hasTPSL = position.TakeProfit && position.TakeProfit > 0 || position.StopLoss && position.StopLoss > 0;
        var mode = hasTPSL ? 'Edit' : 'Add';
        var button = /*#__PURE__*/_react["default"].createElement(_Button.Button, {
          type: "button",
          variant: "secondary-color",
          size: "sm",
          onClick: function onClick() {
            return openAddEditTPSLModal(position, mode);
          }
        }, t(mode));
        if (hasTPSL) {
          var _position$quoteProduc, _position$quoteProduc2;
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: baseClass('tpsl-container')
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: baseClass('cell')
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: baseClass('cell-line1')
          }, !position.TakeProfit // show dash if no TP or if equal to 0
          ? '-' : formatMoney(position.TakeProfit, (_position$quoteProduc = position.quoteProduct) === null || _position$quoteProduc === void 0 ? void 0 : _position$quoteProduc.Product)), /*#__PURE__*/_react["default"].createElement("div", {
            className: baseClass('cell-line2-primary')
          }, !position.StopLoss // show dash if no SL or if equal to 0
          ? '-' : formatMoney(position.StopLoss, (_position$quoteProduc2 = position.quoteProduct) === null || _position$quoteProduc2 === void 0 ? void 0 : _position$quoteProduc2.Product))), button);
        }
        return button;
      },
      meta: {
        textAlign: 'center'
      }
    }, {
      header: t('Close By'),
      id: 'CloseBy',
      size: 130,
      meta: {
        fixedWidth: true
      },
      cell: function cell(_ref10) {
        var row = _ref10.row;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: baseClass('close-buttons')
        }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
          type: "button",
          variant: "secondary-color",
          size: "sm",
          onClick: function onClick() {
            return openClosePositionModal(row.original, 'Limit');
          }
        }, t('Limit')), /*#__PURE__*/_react["default"].createElement(_Button.Button, {
          type: "button",
          variant: "danger",
          size: "sm",
          onClick: function onClick() {
            return openClosePositionModal(row.original, 'Market');
          }
        }, t('Market')));
      }
    }];
  }, [t, notionalProduct, openAddEditTPSLModal, openClosePositionModal]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FuturesAddEditTPSLModal["default"], null), /*#__PURE__*/_react["default"].createElement(_FuturesClosePositionModal["default"], {
    notionalProduct: notionalProduct
  }), /*#__PURE__*/_react["default"].createElement(_table.Table, {
    className: baseClass(),
    columns: columns,
    data: data,
    stickyColumns: {
      right: ['Actions']
    },
    loading: fetching,
    emptyMessage: t('No data is available'),
    pagination: (0, _react.useMemo)(function () {
      return usePagination ? {
        pageSize: maxLines,
        variant: 'simple'
      } : undefined;
    }, [usePagination, maxLines]),
    scrollable: true
  }));
};

/*
 t('Positions', { ns: 'order' });
 */

FuturesOpenPositionsComponent.title = 'Positions';
FuturesOpenPositionsComponent.propTypes = {
  data: _propTypes["default"].array.isRequired,
  notionalProduct: _propTypes["default"].shape({
    DecimalPlaces: _propTypes["default"].number.isRequired,
    Product: _propTypes["default"].string.isRequired
  }),
  openAddEditTPSLModal: _propTypes["default"].func.isRequired,
  openClosePositionModal: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = FuturesOpenPositionsComponent;